import styled , { css }  from "styled-components";

//region style
//transform: translate(-50%, -50%);
const DsecLogoOuterDiv = styled.div`  

${(props) => {

  if (props.theme.isMobile || props.theme.isTablet) {
    return css`
    margin-top:0;
    `;
  }
  else
  {
    return css`
    margin-top:160px;
    `;
  }
}}

  width: 100%;
  display: flex;
  padding: 0 2%;
`;

const DsecLogo = styled.a`
    background-image: url("${process.env.PUBLIC_URL}/images/dsecLogo.png");
    width: 150px;
    height: 58px;
    background-size: cover;
    cursor: pointer;
    margin-left: auto;
    
    ${(props) => {

      if (props.theme.isMobile || props.theme.isTablet) {
        return css`
        margin-bottom: 20px;
          margin-top: 0;
        `;
      }
      else
      {
        return css`
        margin-bottom: 12px;
          margin-top: 40px;
        `;
      }
    }}
`;

//endregion

function DSEClogo(props: any) {

    return (
      <DsecLogoOuterDiv>
        <DsecLogo href="https://dsec.gov.mo/"/>
      </DsecLogoOuterDiv>
    );
}

export default DSEClogo;
